"use strict";

angular.module('app.shared.services')
    .factory("sessionService", sessionService);

sessionService.$inject = ['$http', '$q', '$rootScope', '$window', 'Base64', 'appGlobals', 'httpRequest', 'utilFunctions', '$location'];

function sessionService($http, $q, $rootScope, $window, Base64, appGlobals, httpRequest, utilFunctions, $location) {


    var baseurl = appGlobals.baseApiUrl;
    var baseciurl = appGlobals.baseApiUrl;
    var baseCompUrl = appGlobals.baseApiUrl;
    var baseApiUrl = appGlobals.baseApiUrl;

    var currentUser = {};
    var KEY = 'currentUser';
    var appInfoKEY = 'userAppInfo';

    var locations = null;
	var persons = null;

	var cadLogin = {};

	var setCadData = function () {
		return $q(function (resolve, reject) {
			console.log("setCadData");
			cadLogin.UserID = $location.search().userID;
			cadLogin.ModuleKey = $location.search().moduleKey;
			cadLogin.OpenID = $location.search().openID;
			cadLogin.OpenKey = $location.search().openKey;
            cadLogin.TranType = $location.search().tranType;
            cadLogin.TransmittalKey = $location.search().transmittalKey;
            cadLogin.WebPage = $location.search().webPage;
			resolve();
		});
	};

	var getCadData = function (prop) {
		return cadLogin[prop];
	};

	var cadAutoLogin = function (userID, moduleKey) {
		userID = encodeURIComponent(userID);
		userID = userID.replace(new RegExp("'", 'g'), "''");
		var url = appGlobals.baseApiUrl + "users/cadAutoLogin?userID=" + userID + "&moduleKey=" + moduleKey;
		return httpRequest.doGetRequest(url)
	};

	var autoLogin = function (userID) {
		userID = encodeURIComponent(userID);
		userID = userID.replace(new RegExp("'", 'g'), "''");
		var url = appGlobals.baseApiUrl + "users/checkAutologin?userID=" + userID;
		return httpRequest.doGetRequest(url)
	};

    var requestUsers = function () {
        var url = baseurl + "persons" + "?include=users, PersonDetails, users.UserGroups, users.UserGroups.UserLocGroups";
        return httpRequest.doGetRequest(url)
    };

    var requestLocations = function () {
        var url = baseciurl + "locations";
        return httpRequest.doGetRequest(url)
    };


    var getCompanies = function () {
        var url = baseCompUrl + "companies";
		return httpRequest.doGetRequest(url);
    };

    var getErps = function (successCallBack, errorCallback) {
        var url = baseciurl + "enterprises";
		return httpRequest.doGetRequest(url);
    };

    var setProperties = function (user) {
        currentUser = user;
    };

    var isLoggedIn = function () {
        return $q(function (resolve, reject) {
            //CHECK COOKIE
            var currentUser = $.cookie('currentValidUser') || null;
            var theLocalStorage = localStorage.getItem("locations");

            if (currentUser == null || currentUser == "null") {
                reject();
                $window.location.assign("/");
            }
            else {
                var login = JSON.parse(currentUser);

                var appInfo = JSON.parse($window.sessionStorage.getItem(appInfoKEY));

                if (appInfo !== null) {
                    if (localStorage.locations.length == 0) {
                        $.ajax({
                            type: 'GET',
                            url: "/api/users/GetUserLocations?userid=" + login.UserID,
                            success: function (locations) {
                                localStorage.setItem('locations', JSON.stringify(locations));

                                var theAppInfo = JSON.parse($window.sessionStorage.getItem("userAppInfo"));
                                var newAppInfo = {
                                    LocKey: theAppInfo.LocKey,
                                    CompanyKey: theAppInfo.CompanyKey,
                                    ERPKey: theAppInfo.ERPKey,
                                    ModuleKey: appGlobals.moduleKey,
                                    locations: locations
                                };
                                $window.sessionStorage.setItem(appInfoKEY, JSON.stringify(newAppInfo));
                                return resolve(login);
                            }
                        });
                    }
                    else {
                        //setCredentials(login.UserID, login.DBPassword, appInfo.LocKey, appInfo.ERPKey, login.UserName, appInfo.locations, false, false,null);
                        return resolve(login);
                    }

                }
                else {
                    //setupAuthData(JSON.parse(currentUser));
                    return resolve(login);
                }
            }
        });
    };

    var getCurrentUser = function () {

        var user = $.cookie('currentValidUser') || null;
        if (user != null) {
            user = JSON.parse(user);
        }
        else {
			return {};
        }

        var appInfo = JSON.parse($window.sessionStorage.getItem(appInfoKEY)) || null;

        if (appInfo !== null) {
            user.LocKey = appInfo.LocKey;
            user.CompanyKey = appInfo.CompanyKey;
            user.ERPKey = appInfo.ERPKey;
            user.locations = appInfo.locations;
        }

        return user;
    };

    var checkDatabaseVersion = function () {
        var url = appGlobals.baseApiUrl + "databaseversion/getVersionData";
        return httpRequest.doGetRequest(url);
    };

	var setCredentials = function (personKey, userid, langID, sessionToken, moduleKey, lockey, companyKey, erpkey, username, locs, bRememeberMe, bSaveCookie, bSaveUser, primaryLocKey, personImage, useWinAuth, hostName) {

        //var authdata = Base64.encode(userid + ':' + password);
		var user = {
			PersonKey: personKey,
			UserID: userid,
            UserName: username,
			LangID: langID,
			UseWinAuth: useWinAuth,
            authdata: sessionToken
        };

        if (personImage != undefined) {
            localStorage.setItem('personImage', personImage);
        } else {
            localStorage.setItem('personImage', null);
        }

        //STORE USER APP INFO PER SESSION
        var appInfo = JSON.parse($window.sessionStorage.getItem(appInfoKEY));

        if (appInfo == null) {
            var appInfo = {
                LocKey: lockey,
                CompanyKey: companyKey,
                ERPKey: erpkey,
                ModuleKey: moduleKey,
                locations: locs
            };
            $window.sessionStorage.setItem(appInfoKEY, JSON.stringify(appInfo));
        }

        $.cookie('currentValidUser', JSON.stringify(user));

        localStorage.setItem('locations', JSON.stringify(locs));

        //$.cookie('locations', JSON.stringify(locs));

		$.cookie('primaryLocKey', primaryLocKey);
		$.cookie('clientHostName', hostName);

        if (bSaveUser) {
            $.cookie('savedUser', userid, { expires: 1 });
        } else if (!bSaveUser && bSaveUser !== null) {
            //$.cookie("savedUser", null, { path: '/' });
            $.removeCookie('savedUser', { path: '/' });
        }

        if (appInfo !== null) {
            user.LocKey = appInfo.LocKey;
            user.CompanyKey = appInfo.CompanyKey;
			user.ERPKey = appInfo.ERPKey;
            user.locations = appInfo.locations;
        }

        setProperties(user);
    };

    var clearCredentials = function () {
        var user = null;
        //REMOVE THE COOKIE
        $.removeCookie('currentValidUser', { path: '/' });
        $.removeCookie('primaryLocKey', { path: '/' });

        $window.sessionStorage.removeItem(appInfoKEY);
        $window.localStorage.removeItem('locations');
        $window.localStorage.removeItem('personImage');
        setProperties(user);
        $window.location.assign("/");
    };

    var changeLocation = function (loc) {

        var appInfo = JSON.parse($window.sessionStorage.getItem(appInfoKEY));

        if (appInfo !== null) {
            appInfo.LocKey = loc.LocKey;
            appInfo.CompanyKey = loc.CompanyKey;
            appInfo.ERPKey = loc.ERPKey;
            $window.sessionStorage.setItem(appInfoKEY, JSON.stringify(appInfo));
        }

        $window.location.assign($window.location.pathname);
    };

    var changeModule = function (modKey) {
        var appInfo = JSON.parse($window.sessionStorage.getItem(appInfoKEY));
        if (appInfo !== null) {
            appInfo.ModuleKey = modKey;
            $window.sessionStorage.setItem(appInfoKEY, JSON.stringify(appInfo));
        }
    };

    function setupAuthData(currentUser) {
        var primaryLocKey = $.cookie('primaryLocKey') || null;

        var locations = localStorage.getItem('locations') || null;
        locations = JSON.parse(locations);

        var userID = currentUser.UserID;

        //THIS METHOD WORKS - DOMINICK
        var currLocKey = $window.location.href.split('=')[1];
        if (currLocKey != undefined) {
            currLocKey = currLocKey.split("#")[0];
        } else {
            // If we are here and dont have the lockey in the URL, we can just take the cookie loc key.. They must of went to the URL without the location attached
            currLocKey = $.cookie('primaryLocKey');
        }

        //THIS METHOD WAS NOT WORKING
        //var currLocKey = $location.search().l;        
        //if (currLocKey==null){
        //    currLocKey = primaryLocKey;
        //}

        var loc = utilFunctions.findByProperty(locations, 'LocKey', parseInt(currLocKey));
        var lockey = loc.LocKey;
        var companyKey = loc.CompanyKey;
        var erpkey = loc.ERPKey;

        var appInfo = {
            LocKey: lockey,
            CompanyKey: companyKey,
            ERPKey: erpkey,
            ModuleKey: appGlobals.moduleKey,
            locations: locations
        };
        $window.sessionStorage.setItem(appInfoKEY, JSON.stringify(appInfo));
    }


    var filterByUser = function (theUser, userID, shortLocs) {
        var filtered = [];
        var userid = userID;

        var user = theUser;

        if (user !== null) {
            var userlocs = [];
            for (var i = 0; i < theUser.Users[0].UserGroups.length; i++) {
                var group = theUser.Users[0].UserGroups[i];
                for (var y = 0; y < group.UserLocGroups.length; y++) {
                    userlocs.push(group.UserLocGroups[y]);
                }
            }
            for (var j = 0; j < userlocs.length; j++) {
                var row = utilFunctions.findByProperty(shortlocs, 'LocKey', userlocs[j].LocKey);
                if (row) {
                    var idx = indexOfExisting(filtered, 'LocKey', userlocs[j].LocKey);
                    if (idx == null) {
                        filtered.push(row);
                    }
                }
            }
        }
        return filtered;
    };

	return {
		setCadData: setCadData,
		getCadData: getCadData,
		cadAutoLogin: cadAutoLogin,
		autoLogin: autoLogin,
        setCredentials: setCredentials,
        clearCredentials: clearCredentials,
        getCurrentUser: getCurrentUser,
        checkDatabaseVersion: checkDatabaseVersion,
        setProperties: setProperties,
        changeLocation: changeLocation,
        changeModule: changeModule,
        isLoggedIn: isLoggedIn,
        getErps: getErps,
        getCompanies: getCompanies
    };
}